module.exports = __webpack_public_path__ + "assets/img/Group_259@2x.21533346.png";